export const INIT_UNSUBSCRIBE_EMAIL_GROUPS = [
     {
          id: 223013,
          name: 'Account Related Emails',
          description: 'The email related to your account has been unsubscribed. We recommend signing up for these!',
          suppressed: false,
          is_default: true,
     },
     {
          id: 223014,
          name: 'Marketing & Promotional',
          description: 'Emails related to Marketing & Promotional have been unsubscribed.',
          suppressed: false,
          is_default: false,
     },
];

export const PREFERENCES = {
     RECEIVING: 'receiving',
     NOT_RECEIVING: 'not-receiving',
};

export const PRODUCT_EMAIL_TYPE = {
     CE_CERTIFICATE: 'ce-certificate',
     CERTIFICATE_OF_TRAINING: 'certificate-of-training',
     CHOOSE_EVENT_DATE: 'choose-event-date',
     CLAIM_SEAT_REMINDER: 'claim-seat-reminder',
     COMPLETE_SURVEY: 'complete-survey',
     COURSE_EXPIRATION: 'course-expiration',
     DAY_OF_TRAINING_EVENT: 'day-of-training-event',
     EMAIL_PREFERENCES: 'email-preferences',
     MASK_LINK: 'mask-link',
     NEW_TRAINING_PRODUCTS: 'new-training-products',
     PRODUCT_ACCESS: 'product-access',
     PURCHASE_CE: 'purchase-ce',
     REMAINING_LINK_INVENTORY: 'remaining-link-inventory',
     UPCOMING_TRAINING_EVENT: 'upcoming-training-event',
};
